<script>
	import axios from 'axios'
	import cookies from 'js-cookie'

	export default {
		data() {
			return {
				ip: null,

				error: false,
				submitting: false,
				submitted: false,
			}
		},

		methods: {
			submit(fields) {
				if (this.submitting) {
					return new Promise(() => {})
				}

				this.submitting = true

				const data = {
					context: {
						hutk: cookies.get('hubspotutk'),
						ipAddress: this.ip,
					},

					pageTitle: document.title,
					pageUri: document.URL,

					fields,
				}

				if (process.env.NODE_ENV === 'production') {
					return axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${this.portalId}/${this.formId}`, data).then(() => {
						this.submitted = true
						this.submitting = false
					}).catch(() => {
						this.submitting = false
						this.error = true
					})
				}

				return new Promise(resolve => {
					resolve()
					this.submitted = true
					this.submitting = false
				})
			},
		},

		mounted() {
			axios.get('https://api.ipify.org?format=json').then(response => {
				this.ip = response.data.ip
			}).catch(() => {})
		},

		props: {
			portalId: {
				default: '1846077',
				required: false,
				type: String,
			},

			formId: {
				required: true,
				type: String,
			}
		},

		render() {
			return this.$scopedSlots.default({
				error: this.error,
				submitting: this.submitting,
				submitted: this.submitted,

				submit: this.submit,
			})
		},
	}
</script>
